import { apiUri } from '../appConfig';
import handleErrorRequest from './handleErrorRequest';

const restaurantDetail = (id) => (
	fetch(`${apiUri}/restaurant/${id}`)
		.then((res) => handleErrorRequest(res))
);

export default restaurantDetail;



// WEBPACK FOOTER //
// ./src/js/request/restaurantDetail.js